/* eslint-disable no-promise-executor-return */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import {
    GeoJSON,
    MapContainer,
    WMSTileLayer,
    Marker,
    Tooltip,
    TileLayer,
    useMap,
    useMapEvents
} from 'react-leaflet';
import L from 'leaflet';
import { isMobile, isIPad13 } from 'react-device-detect';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css'; // Import CSS
import 'leaflet-contextmenu/dist/leaflet.contextmenu'; // Import the plugin

import parse from 'html-react-parser';
import ReactLeafletDriftMarker from 'react-leaflet-drift-marker';
import queryString from 'query-string';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { Button } from '@mui/material';
import {
    setNorthernNeckGrants,
    setCivilWarProperties,
    setCemeteries,
    selectNorthernNeckGrantsLayerEnabled,
    selectNorthernNeckGrants,
    selectCivilWarProperties,
    selectCivilWarPropertiesLayerEnabled,
    selectCemeteries,
    select1958PropertiesLayerEnabled,
    setPhotos,
    selectPhotos,
    setPlaces,
    setSharedUrl,
    selectPlaces,
    selectCurrentCommunity,
    setCurrentCommunity,
    selectAerial1937Enabled,
    selectWesternSolarEnabled,
    selectDataCentersEnabled
} from './mapSlice';
import {
    selectCurrentStory, setCurrentStory
} from '../stories/storySlice';
import {
    mapConfig,
    coordinates,
    communities,
    defaultReqParams,
    endpoints,
    markerIcons,
    linkMarkerIcons,
    availableYears,
    allowedContextMenuClasses
} from '../../app/constants';
import {
    closerLookLandmarks
} from '../../app/content';
import {
    summaryContent
} from '../../app/summaries';
import './map.css';
import {
    selectLandmarks,
    setCloserLookLandmarks,
    setLandmarks,
    setLoading,
    selectMinimized,
    setMinimized
} from '../landmark/landmarkSlice';
import { setCurrentCloserLook, selectCurrentCloserLook } from '../closerLook/closerLookSlice';
import { setAbout } from '../dialogs/dialogSlice';
import { selectYear, showAll, setYear } from '../year/yearSlice';
import { selectCurrentPlats } from '../plats/platSlice';
import { setCurrentPhoto } from '../photoView/photoViewSlice';
import { setCurrentSummary } from '../summary/summarySlice';
import { photos as photosLibrary } from '../../app/photos';
import PhotoMarker from './PhotoMarker';
import PhotoView from '../photoView/photoView';
import Landmark from '../landmark/Landmark';
import PlatDetails from '../plats/platDetails';
import ThreeDViewer from '../dialogs/ThreeDViewer';
import {
    coordinateCopyCallback, generateLandGrantColor, generateLandmarkLabel, generatePlaceLabel, nap, openToGoogleCallback, isSummaryPopulated, getFunctionalYear
} from '../../app/utilities';

export default function Map() {
    const dispatch = useDispatch();

    // Selectors
    const currentCommunity = useSelector(selectCurrentCommunity);
    const photos = useSelector(selectPhotos);
    const places = useSelector(selectPlaces);
    const currentCloserLook = useSelector(selectCurrentCloserLook);
    const northernNeckGrantsLayerOn = useSelector(selectNorthernNeckGrantsLayerEnabled);
    const properties1958LayerOn = useSelector(select1958PropertiesLayerEnabled);
    const currentPlats = useSelector(selectCurrentPlats);
    const northernNeckGrants = useSelector(selectNorthernNeckGrants);
    const civilWarProperties = useSelector(selectCivilWarProperties);
    const civilWarPropertiesOn = useSelector(selectCivilWarPropertiesLayerEnabled);
    const aerial1937On = useSelector(selectAerial1937Enabled);
    const westernSolarOn = useSelector(selectWesternSolarEnabled);
    const dataCentersOn = useSelector(selectDataCentersEnabled);
    const landmarks = useSelector(selectLandmarks);
    const landmarksMinimized = useSelector(selectMinimized);
    const cemeteries = useSelector(selectCemeteries);
    const currentStory = useSelector(selectCurrentStory);
    const currentYear = useSelector(selectYear);
    const showAllEnabled = useSelector(showAll);

    const [driftMarkerValue, setDriftMarkerValue] = useState({ lat: 38.89612486430293, lng: -77.44526949595726 });
    const mapRef = useRef(null);

    // Function declarations to satisfy 'Function component is not a function declaration'
    function showContextMenu(e) {
        return allowedContextMenuClasses.includes(e.originalEvent.target.classList[0]);
    }

    function retrieveCloserLook(landmark) {
        if (closerLookLandmarks.indexOf(landmark.properties.uid) > -1) {
            dispatch(setCurrentCloserLook(landmark));
            mapRef.current.target.setView([landmark.geometry.coordinates[1], landmark.geometry.coordinates[0] - 0.0045], 16);
            const urlParams = new URLSearchParams({
                uid: landmark.properties.uid
            });
            window.history.replaceState(null, '', `landmark?${urlParams.toString()}`);
            return true;
        }
        return null;
    }

    function evaluateQueryParams(query, queryPath, retrievedLandmarks) {
        if (queryPath === '/landmark') {
            if (!currentCloserLook && query.uid && retrievedLandmarks) {
                const urlLandmark = retrievedLandmarks.filter((f) => f.properties.uid === parseInt(query.uid))[0];
                if (urlLandmark) {
                    dispatch(setAbout(false));
                    retrieveCloserLook(urlLandmark);
                    dispatch(setSharedUrl(true));
                }
            }
        } else if (queryPath === '/image' && query.id) {
            const urlPhoto = photosLibrary.filter((p) => p.id === parseInt(query.id))[0];
            if (urlPhoto) {
                dispatch(setAbout(false));
                dispatch(setCurrentPhoto(urlPhoto));
                dispatch(setSharedUrl(true));
            }
        } else if (queryPath === '/summary' && query.id) {
            if (summaryContent[query.id]) {
                dispatch(setAbout(false));
                dispatch(setCurrentSummary(query.id));
                dispatch(setSharedUrl(true));
            }
        } else {
            dispatch(setSharedUrl(false));
        }
    }

    function retrieveSummary(place) {
        const foundId = isSummaryPopulated(null, place, currentYear);
        const nameKey = `name_${getFunctionalYear(currentYear)}`;
        const foundCommunity = communities.find((c) => c.name === place.properties[nameKey] || c.altName === place.properties[nameKey]);
        if (foundId) {
            dispatch(setCurrentSummary(foundId));
            dispatch(setCurrentCommunity(foundCommunity.id));
            mapRef.current.target.flyTo([foundCommunity.center[0], foundCommunity.center[1]], foundCommunity.zoom);
            const urlParams = new URLSearchParams({ id: foundId });
            window.history.replaceState(null, '', `summary?${urlParams.toString()}`);
        }
    }

    function generateStoryCharacterIcon(character) {
        if (character === 'sr71') {
            return new L.Icon({
                iconUrl: './png/sr71-circle.png',
                iconSize: [18, 18]
            });
        }
    }

    function generateIcon(feature) {
        let iconProperties = null;
        if (closerLookLandmarks.indexOf(feature.properties.uid) > -1) {
            if (feature.properties.type in linkMarkerIcons) {
                iconProperties = linkMarkerIcons[feature.properties.type];
            }
        } else if (feature.properties.type in markerIcons) {
            iconProperties = markerIcons[feature.properties.type];
        }
        return new L.Icon(iconProperties);
    }

    function determinePlaceStyling(place) {
        return isSummaryPopulated(null, place, currentYear) ? `place-${currentYear}-clickable` : `place-${currentYear}`;
    }

    function renderYearWMS(givenYear) {
        if (parseInt(givenYear)) {
            const foundAvailableYear = availableYears.find((ay) => parseInt(ay.id) === givenYear);
            if (mapRef.current) {
                if (mapRef.current.target.getZoom() > mapConfig.MAXZOOM[givenYear]) {
                    mapRef.current.target.setZoom(mapConfig.MAXZOOM[givenYear]);
                }
                mapRef.current.target.setMaxZoom(mapConfig.MAXZOOM[givenYear]);
            }
            return (
                <WMSTileLayer
                    layers={foundAvailableYear.wms}
                    url={`${endpoints.GEOSERVER}/wms`}
                    key={foundAvailableYear.id}
                    format="image/png"
                    BGCOLOR={foundAvailableYear.bgColor || null}
                    zIndex={0}
                />
            );
        }
        return <TileLayer url={endpoints.OSM} key="now" zIndex={0} />;
    }

    function assessFeatureEligibility(feature) {
        if (showAllEnabled) return true;
        if ((feature.properties.year <= (parseInt(currentYear) + 5)) || currentYear === 'now') {
            if (feature.properties.range) {
                return feature.properties.range >= parseInt(currentYear);
            }
            return !!feature.properties.extant;
        }
        return false;
    }

    function assessPhotoEligibility(photo) {
        if (currentYear === 'now') return true;
        return photo.subjectYear <= (parseInt(currentYear) + 5);
    }

    function MapHookWrapper() {
        const map = useMap();
        map.on('click', () => map.contextmenu.hide());
        useMapEvents({
            contextmenu(e) {
                if (showContextMenu(e)) {
                    mapRef.current.target.contextmenu.showAt(e.latlng);
                }
            }
        });
        return null;
    }

    // Effects
    useEffect(() => {
        dispatch(setPhotos(photosLibrary));
        function retrieveData(typeNames, setter) {
            axios.get(`${endpoints.GEOSERVER}/ows`, {
                params: {
                    typeNames,
                    bbox: `${coordinates.BOUNDS[0][1]},${coordinates.BOUNDS[0][0]},${coordinates.BOUNDS[1][1]},${coordinates.BOUNDS[1][0]}`,
                    ...defaultReqParams
                }
            })
                .then(({ data }) => dispatch(setter(data)))
                .catch((err) => console.error(err));
        }

        if (!northernNeckGrants) retrieveData('cite:1725_grants_loco_repro', setNorthernNeckGrants);
        if (!civilWarProperties) retrieveData('cite:fairfax_1860_properties', setCivilWarProperties);
        if (!cemeteries) {
            axios.get(`${endpoints.GEOSERVER}/ows`, { params: { typeNames: 'cite:cemeteries', ...defaultReqParams } })
                .then(({ data }) => dispatch(setCemeteries(data.features)));
        }
        if (!places) {
            axios.get(`${endpoints.GEOSERVER}/ows`, { params: { typeNames: 'cite:villages', ...defaultReqParams } })
                .then(({ data }) => dispatch(setPlaces(data.features)));
        }

        dispatch(setCloserLookLandmarks(closerLookLandmarks));

        if (!landmarks) {
            dispatch(setLoading(true));
            axios.get(`${endpoints.GEOSERVER}/ows`, { params: { typeNames: 'cite:landmarks', ...defaultReqParams } })
                .then(({ data }) => {
                    dispatch(setLandmarks(data.features));
                    dispatch(setLoading(false));
                    evaluateQueryParams(queryString.parse(window.location.search), window.location.pathname, data.features);
                });
        }
    }, []);

    useEffect(() => {
        if (currentCommunity !== null) {
            const foundCommunity = communities.find((c) => c.id === currentCommunity);
            if (!landmarksMinimized) dispatch(setMinimized(true));
            if (foundCommunity.year) dispatch(setYear(foundCommunity.year));
            mapRef.current.target.flyTo([foundCommunity.center[0], foundCommunity.center[1]], foundCommunity.zoom);
        }
    }, [currentCommunity]);

    async function iterateStoryPath() {
        for (let i = 0; i < currentStory.path.length; i++) {
            if (i > 0 && !mapRef.current.target.getBounds().contains(currentStory.path[i].position)) {
                mapRef.current.target.setView(currentStory.path[i].position, 16);
            }
            setDriftMarkerValue(currentStory.path[i].position);
            await nap(500);
        }
        await nap(500);
        dispatch(setCurrentStory(null));
    }

    return (
        <div className="map">
            {currentStory && (
                <Button variant="contained" onClick={iterateStoryPath} endIcon={<PlayCircleIcon />} className="run-story">
                    Play
                </Button>
            )}
            <MapContainer
                whenReady={(mapInstance) => {
                    mapRef.current = mapInstance;
                    mapInstance.target.contextmenu.addItem({ text: 'Copy coordinates', callback: coordinateCopyCallback });
                    mapInstance.target.contextmenu.addItem({ text: 'Show location in Google Maps', callback: openToGoogleCallback });
                }}
                center={coordinates.CENTER}
                zoom={15}
                minZoom={mapConfig.MINZOOM}
                maxZoom={mapConfig.MAXZOOM[currentYear]}
                scrollWheelZoom
                className="map-container"
                maxBounds={coordinates.BOUNDS}
                maxBoundsViscosity={mapConfig.VISCOSITY}
                zoomSnap={mapConfig.ZOOMSNAP}
            >
                <MapHookWrapper />
                {renderYearWMS(currentYear)}

                {properties1958LayerOn && (
                    <WMSTileLayer layers="1958_properties_dulles_condemned" url={`${endpoints.GEOSERVER}/wms`} transparent opacity={0.5} format="image/png" zIndex={20} />
                )}

                {northernNeckGrants && northernNeckGrantsLayerOn && northernNeckGrants.features.map((grant) => (
                    <GeoJSON
                        key={grant.id}
                        data={grant}
                        style={() => ({
                            color: generateLandGrantColor(grant.properties.ACRES, 15000),
                            weight: 1,
                            opacity: 1.0,
                            dashArray: 4
                        })}
                    >
                        <Tooltip className="land-grant" direction="top" offset={[0, 5]} opacity={1} permanent>
                            {grant.properties.OWNER} <br />
                            <span style={{ fontSize: '10px', fontFamily: 'Times' }}>
                                {grant.properties.ACRES} acres, {grant.properties.YEAR}
                            </span> <br />
                            <span style={{ fontSize: '8px', fontFamily: 'Times', opacity: 0.25 }}>
                                {grant.properties.DEED}
                            </span>
                        </Tooltip>
                    </GeoJSON>
                ))}

                {civilWarProperties && civilWarPropertiesOn && civilWarProperties.features.map((grant) => (
                    <GeoJSON
                        key={grant.id}
                        data={grant}
                        style={() => ({
                            color: generateLandGrantColor(grant.properties.acreage, 2100),
                            weight: 1,
                            opacity: 1.0,
                            dashArray: 4
                        })}
                    >
                        <Tooltip direction="top" offset={[0, 5]} opacity={1} permanent>
                            <span style={{ opacity: 0.5, fontSize: '12px', fontFamily: 'Times' }}>{grant.properties.owner}</span><br />
                            <span style={{ fontSize: '10px', opacity: 0.5 }}>{grant.properties.acreage} acres</span><br />
                            <span style={{ fontSize: '8px', opacity: 0.25 }}>{grant.properties.deed}</span>
                        </Tooltip>
                    </GeoJSON>
                ))}

                {currentPlats && currentPlats.map((plat) => (
                    <WMSTileLayer layers={plat} url={`${endpoints.GEOSERVER}/wms`} transparent format="image/png" zIndex={100} key={plat} />
                ))}

                {westernSolarOn && <WMSTileLayer layers="western_solar_2025" url={`${endpoints.GEOSERVER}/wms`} transparent format="image/png" zIndex={10} opacity={0.75} />}
                {dataCentersOn && <WMSTileLayer layers="data_centers_2026" url={`${endpoints.GEOSERVER}/wms`} transparent format="image/png" zIndex={10} opacity={1.0} />}
                {aerial1937On && <WMSTileLayer layers="1937" url={`${endpoints.GEOSERVER}/wms`} transparent format="image/png" zIndex={5} />}

                {cemeteries && cemeteries.filter(assessFeatureEligibility).map((cemetery) => (
                    <GeoJSON style={() => ({ color: '#96946f', weight: 1, dashArray: 2 })} data={cemetery} key={`${currentYear}_${cemetery.id}`}>
                        <Tooltip className={`cemetery-${currentYear}`} direction="right" offset={[0, 5]} opacity={0.5} permanent>
                            ✝ {cemetery.properties.name}
                        </Tooltip>
                    </GeoJSON>
                ))}

                {places && currentYear !== 'now' && currentYear !== 1994 && places.map((place) => (
                    <Marker
                        key={`${place.id}-${currentYear}`}
                        position={[place.geometry.coordinates[1], place.geometry.coordinates[0]]}
                        icon={L.divIcon({ iconSize: [100, 30], iconAnchor: [70, -35], className: 'place-marker' })}
                        eventHandlers={{ click: () => retrieveSummary(place) }}
                    >
                        <Tooltip className={determinePlaceStyling(place)} direction="top" offset={[-45, 35]} opacity={1} permanent interactive>
                            {generatePlaceLabel(place, currentYear)}
                        </Tooltip>
                    </Marker>
                ))}

                {photos && photos.filter(assessPhotoEligibility).map((photo) => photo.coordinates && (
                    <PhotoMarker photo={photo} position={photo.coordinates} key={`photo${photo.id}`} />
                ))}

                {landmarks && landmarks.filter(assessFeatureEligibility).map((feature) => (
                    <Marker
                        key={`${currentYear}_${feature.id}`}
                        icon={generateIcon(feature)}
                        position={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]}
                        eventHandlers={{ click: () => retrieveCloserLook(feature) }}
                        zIndexOffset={500}
                    >
                        <Tooltip direction="top" offset={[-30, -5]} opacity={1} className={`landmark-${currentYear}`} interactive permanent>
                            {parse(generateLandmarkLabel(feature, currentYear))}
                        </Tooltip>
                    </Marker>
                ))}

                {currentStory && (
                    <ReactLeafletDriftMarker position={driftMarkerValue} icon={generateStoryCharacterIcon('sr71')} duration={500} />
                )}

                <PhotoView mapRef={mapRef} />
                <PlatDetails mapRef={mapRef} />
                {(!isMobile || isIPad13) && <Landmark mapRef={mapRef} />}
            </MapContainer>
        </div>
    );
}
